/**
 * Copyright ToolBelt Data Inc., 2020 All Rights Reserved
 * React 19 compatible replacement for react-chat-ui Message class
 */

class Message {
    constructor({ id, message, senderName, bubbleStyles } = {}) {
        this.id = id || 0;
        this.message = message || '';
        this.senderName = senderName || '';
        this.bubbleStyles = bubbleStyles || {};
    }
}

export default Message;
